import {
  Button,
  Icon,
  IconButton,
  RouterState,
  SidebarPriorityItem,
  useResponsiveValue,
} from '@monash/portal-react';
import { MOBILE_RESPONSIVE } from '../../Nav';
import c from './search-button.module.scss';
import { useContext } from 'react';
import {
  SEARCH_PLACEHOLDER,
  SearchContext,
} from '@/components/providers/SearchProvider';
import { FeatureContext, isStringEmpty } from '@monash/portal-frontend-common';
import { SearchContextHoneycomb } from '@/components/providers/search-provider-honeycomb/SearchProviderHoneycomb';

const SearchButton = ({ isInSidebar = false, onClick }) => {
  const responsiveSize = useResponsiveValue(MOBILE_RESPONSIVE);
  const isMobile = responsiveSize === 'S' || responsiveSize === 'XS';

  const { featureFlags } = useContext(FeatureContext);
  const { redirect } = useContext(RouterState);
  const { searchTarget } = useContext(SearchContext);
  const { searchTarget: searchTargetHoneycomb } = useContext(
    SearchContextHoneycomb
  );
  const searchPageUrl = featureFlags?.HONEYCOMB
    ? `/search?query=${
        !isStringEmpty(searchTargetHoneycomb) ? searchTargetHoneycomb : ''
      }`
    : `/search?query=${!isStringEmpty(searchTarget) ? searchTarget : ''}`;

  const ID = 'search';
  const TRACKING_LABEL = 'topnav-search';
  const SEARCH_TEXT = 'Explore';
  const searchButtonLabel = featureFlags?.HONEYCOMB
    ? SEARCH_TEXT
    : searchTarget || SEARCH_PLACEHOLDER;

  return (
    <div className={c.searchContainer}>
      {(() => {
        // Sidebar view
        if (isInSidebar) {
          return (
            <SidebarPriorityItem
              id={ID}
              aria-label={searchButtonLabel}
              icon={<Icon.Search />}
              onClick={() => {
                redirect(searchPageUrl);
                onClick?.();
              }}
              data-tracking-event={TRACKING_LABEL}
            >
              {featureFlags?.HONEYCOMB ? SEARCH_TEXT : SEARCH_PLACEHOLDER}
            </SidebarPriorityItem>
          );
        }

        // Mobile view
        if (isMobile) {
          return (
            <IconButton
              id={ID}
              aria-label={searchButtonLabel}
              className={c.searchButtonMobile}
              onClick={() => {
                redirect(searchPageUrl);
                onClick?.();
              }}
              icon={Icon.Search}
              data-tracking-event={TRACKING_LABEL}
            />
          );
        }

        // Regular view
        return (
          <Button
            size="medium"
            id={ID}
            aria-label={searchButtonLabel}
            icon={<Icon.Search />}
            onClick={() => {
              redirect(searchPageUrl);
            }}
            className={
              featureFlags?.HONEYCOMB ? c.exploreButton : c.searchButton
            }
            data-tracking-event={TRACKING_LABEL}
          >
            <span>{searchButtonLabel}</span>
          </Button>
        );
      })()}
    </div>
  );
};

export default SearchButton;
